module.exports = __webpack_public_path__ + "img/fjmj.e2e7bd64.jpg";